import { render, staticRenderFns } from "./ApprovalApprove.vue?vue&type=template&id=d2737db0"
import script from "./ApprovalApprove.vue?vue&type=script&lang=js"
export * from "./ApprovalApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports